import { axios } from '@complispace/cs-design-system';

const baseURL = process.env.QUICK_LINKS_API_URL;
const sectionBaseUrl = `${baseURL}/v1/linksections`;

const section = {
  // GET /linksections Get all sections
  async getSections(organisations) {
    const queryString = Object.keys(organisations)
      .map((key) => `${key}=${organisations[key]}`)
      .join('&');
    return axios.get(
      `${sectionBaseUrl}?${queryString}&title=&deleted=false&order=priority_desc&order=updated_at_desc&skip=0&limit=10000`
    );
  },

  // POST /linksections Create a new section
  async create(sectionInput) {
    return axios.post(`${sectionBaseUrl}`, sectionInput);
  },

  // POST Update section
  async update(id, obj) {
    return axios.post(`${sectionBaseUrl}/${id}`, obj);
  },

  // POST Multiple updates sections priority
  async updateSectionsPriority(sections, organisation) {
    return axios.post(`${sectionBaseUrl}/priority?organisation=${organisation}`, sections);
  }
};

export default section;
